import React, { useEffect, useState } from "react";
import { Block, Icon } from "../../../../components/Component";
import { Button, Col, Row } from "reactstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Table, TableColumnsType } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import FormSelect from "../../../form-components/SelectComponent";
import NewWorkMaterialModal from "./NewWorkMaterialModal";
import BulkMaterialUpload from "../TenderForMaterial/BulkMaterialUpload";
import Swal from "sweetalert2";

const normalize = (val: any) =>
  (val ?? "").toString().trim().replace(/\s+/g, "").toLowerCase();

const TenderForWorkServiceMain: React.FC<any> = ({ prev, next }) => {
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const { control, reset, setValue, watch, handleSubmit } = useFormContext();
  const { fields, append, remove, update }: any = useFieldArray({
    control,
    name: "items",
  });
  const [activeMaterial, setActiveMaterial] = useState<any>({
    action: null,
    index: null,
    item: null,
  });
  const [source, setSource] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [columns, setColumns] = useState<TableColumnsType<any>>([
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 60,
      fixed: "left",
      render: (_text: any, _record: any, index: number) => {
        return <span>{(currentPage - 1) * pageSize + index + 1}</span>;
      },
    },
    {
      title: "Task Title",
      dataIndex: "taskTitle",
      key: "taskTitle",
      width: 250,
      fixed: "left",
    },
    {
      title: "Task Usage",
      dataIndex: "taskUsage",
      key: "taskUsage",
      width: 200,
    },
    {
      title: "Work Category",
      dataIndex: "workCategoryName",
      key: "workCategoryName",
      width: 200,
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      render: (text: any, record: any) => {
        return (
          <span>
            {text} {record?.uomName}
          </span>
        );
      },
    },
    {
      title: "Installation Required",
      dataIndex: "installationRequired",
      key: "installationRequired",
      width: 150,
      render: (value: any) => (value ? "Yes" : "No"),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 120,
      render: (_text: any, record: any, index: number) => {
        const absoluteIndex = (currentPage - 1) * pageSize + index;
        return (
          <>
            <Button
              size="sm"
              color=""
              onClick={() => {
                setActiveMaterial({
                  action: "edit",
                  index: absoluteIndex,
                  item: record,
                });
              }}
            >
              <Icon name="edit" />
            </Button>
            <Button size="sm" color="" onClick={() => remove(absoluteIndex)}>
              <Icon name="trash" />
            </Button>
          </>
        );
      },
    },
  ]);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);
  const configColumns = (cols: any) => {
    const configredColumns: any = [];
    cols.forEach((col: any) => {
      const { key } = col;
      configredColumns.push(col);
    });
    return configredColumns;
  };

  const addNewRow = () => {
    setActiveMaterial({
      action: "add",
      index: null,
      item: null,
    });
  };

  return (
    <>
      <h6>Tender For Work / Service</h6>
      <Block>
        <form className="form-validate" onSubmit={handleSubmit(() => {})}>
          <Row className="mt-3">
            <div className="col-md-4">
              <FormSelect
                name="source"
                // optionLabel="Source"
                // optionLabelWidth="50px"
                label={"Source"}
                required={true}
                options={[
                  {
                    label: "Work Request(Open)",
                    value: "Work Request(Open)",
                  },
                  {
                    label: "Work BOQ(Work BOQ)",
                    value: "Work BOQ(Work BOQ)",
                  },
                  {
                    label: "New Work(manual)",
                    value: "New Work(manual)",
                  },
                ]}
                placeholder="Select Source"
                onChange={(e: any) => {
                  setSource(e);
                }}
              />
            </div>
          </Row>
          <div style={{ marginTop: "18px" }}></div>
          <div className="d-flex justify-content-end" style={{ gap: "8px" }}>
            {fields.length > 0 && (
              <Button
                color="link"
                size="sm"
                style={{ color: "#e85347", textDecoration: "none" }}
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "This will remove all task lines.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, clear all!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      remove();
                    }
                  });
                }}
              >
                <Icon name="trash" /> &nbsp; Clear All
              </Button>
            )}
            <BulkMaterialUpload
              append={(data: any) => {
                append(data);
              }}
              tenderFor="Service / Works"
            />
          </div>
          <Row>
            <div className="table-responsive">
              <div style={{ width: screenSize - 120 + "px" }}>
                {columns && (
                  <Table
                    columns={configColumns(columns)}
                    dataSource={fields}
                    scroll={{ x: "max-content" }} // Adjust this as necessary
                    expandable={{
                      expandedRowRender: (record: any) => (
                        <div className="expandableBody">
                          <div style={{ flex: 1, textAlign: "left" }}>
                            <p style={{ margin: 0 }}>{record.description}</p>
                            {record.file && record.file[0] && (
                              <div>
                                <PaperClipOutlined /> &nbsp;
                                <a
                                  href={URL.createObjectURL(record.file[0])}
                                  download={record.file[0]?.name}
                                >
                                  {record.file[0]?.name}
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      ),
                    }}
                    locale={{
                      emptyText: (
                        <span
                          style={{
                            height: "300px",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          Please select source and click on "Add New Item" to
                          add service / work.
                        </span>
                      ),
                    }}
                    bordered
                    size="small"
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                    }}
                  />
                )}
              </div>
              <Row
                style={{
                  margin: "20px",
                }}
              >
                <Col className="justify-between">
                  <a
                    aria-disabled={watch("source") ? false : true}
                    onClick={addNewRow}
                    className="addNewItem"
                    style={{
                      pointerEvents: !watch("source") ? "none" : "auto",
                      opacity: !watch("source") ? 0.5 : 1,
                      cursor: !watch("source") ? "not-allowed" : "pointer",
                    }}
                  >
                    <Icon name="plus-round" />
                    <span>Add New Item</span>
                  </a>
                </Col>
              </Row>
            </div>
          </Row>
          <div className="actions clearfix">
            <ul>
              <li>
                <Button
                  title={fields.length === 0 ? "Please add materials" : ""}
                  disabled={
                    fields?.length == 0 ||
                    fields?.find((line: any) => line?.errorFlag)?.errorFlag
                  }
                  color="primary"
                  type="submit"
                  onClick={() => {
                    next();
                  }}
                >
                  Next
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  color="primary"
                  onClick={prev}
                  className="btn-dim btn btn-secondary"
                >
                  Previous
                </Button>
              </li>
            </ul>
          </div>
        </form>
      </Block>
      {activeMaterial?.action && (
        <NewWorkMaterialModal
          modal={!!activeMaterial.action}
          closeModal={() => {
            setActiveMaterial({
              action: null,
              index: null,
              item: null,
            });
          }}
          // materialCategoryOptions={materialCategoryOptions}
          append={(data: any) => {
            for (let i = 0; i < fields.length; i++) {
              let item: any = fields[i];
              if (
                normalize(item.taskTitle) === normalize(data.taskTitle) &&
                normalize(item.taskUsage) === normalize(data.taskUsage)
              ) {
                Swal.fire({
                  icon: "error",
                  title: "Duplicate Task",
                  text: "A task with the same title and usage already exists.",
                });
                return;
              }
            }

            append(data);
          }}
          update={(index: any, data: any) => {
            const duplicate = fields.find(
              (item: any, idx: number) =>
                idx !== index &&
                normalize(item.taskTitle) === normalize(data.taskTitle) &&
                normalize(item.taskUsage) === normalize(data.taskUsage)
            );

            if (duplicate) {
              Swal.fire({
                icon: "error",
                title: "Duplicate Task",
                text: "A task with the same title and usage already exists.",
              });
              return;
            }
            update(index, { ...data, errorFlag: false, errorMessage: [] });
          }}
          formData={activeMaterial}
          source={source}
          siteId={watch("projectId")}
          deliveryAddressType={watch("deliveryAddressType")}
        />
      )}
    </>
  );
};

export default TenderForWorkServiceMain;
